import { render } from "./itemForm.vue?vue&type=template&id=25cfb5ea&scoped=true&ts=true"
import script from "./itemForm.vue?vue&type=script&lang=ts"
export * from "./itemForm.vue?vue&type=script&lang=ts"

import "./itemForm.vue?vue&type=style&index=0&id=25cfb5ea&lang=scss&scoped=true"

import exportComponent from "F:\\工作\\project\\kaola\\kaola-project-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25cfb5ea"]])

export default __exports__